export const vendorAliases = {
  "Kickport LLC": "Kicktone Microphones",
};

export const brand_data = [
  {
    displayName: "Empirical Labs",
    Name: "ELI | Empirical Labs Inc. (V)",
    SecondaryName: "ELI-D | Empirical Labs Digital Corp (V)",
    vendorId: 277,
    secondaryVendorId: 276,
    url: "empirical",
    logo: "/brands/eli/eli-logo.png",
    logo_main: "/brands/eli/eli-logo-main.svg",
    website: "https://www.empiricallabs.com/",
    short_desc:
      "Products that work a little easier, a little better, and a lot longer.",
    long_desc:
      "ELI was started in 1988 and functioned mainly as a recording studio and electronic consulting firm. The founder, Dave Derr, was also employed at the time by Eventide as an audio engineer where he was part of the core design team for the H3000, H3500, and DSP4000. His experience at Eventide proved invaluable for his later work. While working alongside Ken Bogdanowicz and Bob Belcher (both now at Soundtoys), Dave was exposed to state of the art engineering and the modern world of digital signal processing (DSP). The first Empirical Labs product – the Distressor – was designed in 1994, tested and revised for several years, and released in 1996. With over twenty-five thousand units sold, it has unquestionably become a modern classic. In 1998, Empirical Labs closed the doors of the recording studio to focus on the growing signal processing business. Today, all Empirical Labs products are still manufactured in the USA and rigorously calibrated and tested by hand.",
  },
  {
    displayName: "Whitestone Audio",
    Name: "Whitestone Audio Instruments, LLC (V)",
    vendorId: 600,
    url: "whitestone",
    logo: "/brands/whitestone/logo.png",
    logo_main: "/brands/whitestone/logo-main.png",
    website: "https://www.whitestoneaudio.com/",
    short_desc: "The Whitestone Audio P331 Tube Loading Amplifier.",
    long_desc:
      "Whitestone Audio Instruments is the brainchild of Dave Rosen and his multi-Grammy® nominated mastering engineer wife Kim Rosen. Much of the way Kim works is exploiting the sound of the input and output gain stages of some of her favorite equalizers and compressors with actual processing bypassed. Just the subtle enhancement some of these analog gain circuits provide often times is just the thing to add a bit of “magic”. The goal for the P331 was to capture this kind of enhancement potential in a line amplifier that delivers the natural clarity of a well-designed tube circuit. At the same time, implementing fully switched controls that introduce harmonics and other carefully implemented, and repeatable, non-linearities to subtly enhance the signal without harming the recording’s original intent.",
  },
  {
    displayName: "Serpent Audio",
    Name: "Serpent Audio, LLC (V)",
    vendorId: 598,
    url: "serpent",
    logo: "/brands/serpent/logo.png",
    logo_main: "/brands/serpent/logo-main.png",
    website: "https://serpentaudio.com/",
    short_desc: "Taking compression to a whole new level.",
    long_desc:
      "Serpent Audio was founded by Mike Pildis in 2010. With an expertise in vintage processing gear, Pildis found ways to recreate the tonal characteristics of these classic units while also improving the feature sets. All units are made in the USA to an exceptional level of craft and workmanship.",
  },
  {
    displayName: "Useful Arts Audio",
    Name: "Useful Arts Audio, LLC (V)",
    vendorId: 281,
    url: "usefularts",
    logo: "/brands/useful/ua_logo_sm.png",
    logo_main: "/brands/useful/logo-main.png",
    website: "https://www.usefulartsaudio.com/",
    short_desc:
      "An aesthetic quest for vibrant, living sound straight from the source.",
    long_desc:
      "Useful Arts was born out of an aesthetic quest for vibrant, living sound straight from the source — not merely a technically clean sound that needs enhancement after enhancement to speak in a mix. Back in the days when the U-47 was a commonly-used “standard” microphone, there were no “standard” preamps — studios used hand-built consoles with custom tube preamps designed to capture the personality of the recording. In the same way, our hand-built products are designed to enhance dynamics and perceived tonal richness, not simply to make a small signal electrically bigger. We invite you to hear for yourself the difference that philosophy makes.",
  },
  {
    displayName: "Wave Distro",
    Name: "Wave Distro",
    vendorId: 594,
    url: "wave-distro",
    logo: "/brands/wave/wave-logo-icon.png",
    website: "https://wavedistro.com/",
    short_desc: "Premium audio distribution and custom PowerGrid solutions.",
    long_desc:
      "Wave Distro is a premier distributor of high-end professional audio equipment, representing some of the industry's most respected brands. Beyond distribution, Wave Distro creates custom solutions including the PowerGrid modular system and signature products like the UBK EL7 Fatso compressor. Originally developed in collaboration with Gregory Scott (UBK) of Kush Audio and produced in conjunction with Empirical Labs, the UBK Fatso has become a favorite tool among producers and engineers seeking character and color in their compression. Wave Distro's PowerGrid Duo enclosures offer innovative rack solutions for professional studio environments."
  },
  {
    displayName: "Quagliardi Pro Audio",
    Name: "Quagliardi Pro Audio (V)",
    vendorId: 6233,
    url: "quagliardi",
    logo: "/brands/quag/icon.png",
    website: "https://www.quagliardiaudio.com/",
    short_desc:
      "Crafting audio experiences.",
    long_desc:
      "Quagliardi Pro Audio is an Argentina based company dedicated to the design and manufacture of high-end audio equipment for studio and stage. Founded in 2020 by Tomás Quagliardi, it already has a range of products in its catalog that have found their place in iconic studios within the Argentine music scene.",
  },
];

export const findBrandByVendor = (vendorName) => {
  const normalizedName = vendorAliases[vendorName] || vendorName;
  return brand_data.find(
    (brand) =>
      brand.Name === normalizedName || brand.SecondaryName === normalizedName
  );
};

// Preferred lookup: match on the stable Method vendor RecordID
// (Item.PrefVendor_RecordID), which does not change when a vendor is renamed
// in QuickBooks/Method. Falls back to findBrandByVendor(name) at call sites.
export const findBrandByVendorId = (vendorId) => {
  if (vendorId === null || vendorId === undefined) return undefined;
  return brand_data.find(
    (brand) =>
      brand.vendorId === vendorId || brand.secondaryVendorId === vendorId
  );
};
